/**
 * Helper directive to remove '.b-landing-links' container from 'landing-banner-and-text.twig' IF both links are not defined.
 * Otherwise banner with text and modifier --partially would look bad, because bottom border would not show up.
 */
app.directive('bLandingLinks', [function () {
	return {
		restrict: 'C',
		link: function(scope, element){
			var links = element.find('a');

			var linksEmpty = true;

			angular.forEach(links, function(link) {
				var linkText = angular.element(link).find('span').text();

				if(linkText) {
					linksEmpty = false;
				}
			});

			if(linksEmpty) {
				element.remove();
			}
		}
	};
}]);